import {useTranslation} from "react-i18next";
import {DisplayParametricResultMode} from "../schema";
import WithTooltip from "../ui/tooltip";
import {HelpCircleIcon} from "../ui/icons";

type props = {
  displayParametricResultMode: DisplayParametricResultMode;
};

export const ParametricResultHelp = ({displayParametricResultMode: displayResultMode}: props) => {
  const {t} = useTranslation();
  const parametricHelpTexts: Record<DisplayParametricResultMode, string> = {
    [DisplayParametricResultMode.RAW_SUM]: t("components.ResultsDisplay.parametricResults.RAW_SUM.helpText"),
    [DisplayParametricResultMode.PERCENTAGE]: t("components.ResultsDisplay.parametricResults.PERCENTAGE.helpText"),
    [DisplayParametricResultMode.SCENARIO_AVG]: t("components.ResultsDisplay.parametricResults.SCENARIO_AVG.helpText")
  };

  return displayResultMode in parametricHelpTexts ? (
    <WithTooltip helpText={parametricHelpTexts[displayResultMode]}>
      <HelpCircleIcon />
    </WithTooltip>
  ) : (
    <></>
  );
};
